import cn from 'classnames'
import * as React from 'react'
import { defineMessages, FormattedMessage, useIntl, MessageDescriptor } from 'react-intl'

import DooerLogo from '../dooer-logo'
import Hamburger from '../hamburger'

import NavLink from './nav-link'
import styles from './navigation.module.scss'
import { DevFeatureMiddleware } from '../../lib/dev-features'

const messages = defineMessages({
  bookingSoftware: { id: 'component.navigation.booking-software', defaultMessage: 'Bokföring' },
  invoiceSoftware: { id: 'component.navigation.invoice-program', defaultMessage: 'Fakturering' },
  payrollSoftware: { id: 'component.navigation.payroll-program', defaultMessage: 'Lön' },
  weBook: { id: 'component.navigation.we-book', defaultMessage: 'Byrå' },
  help: {
    defaultMessage: 'Hjälp',
    id: 'component.navigation.help',
  },
  logIn: { id: 'component.navigation.log-in', defaultMessage: 'Logga in' },

  newCompaniesSignup: {
    defaultMessage: 'Bokföring för nystartade företag',
    id: 'component.navigation.new-companies-book-keeping',
  },
})

interface INavigationProps {
  location: Location
}

const newLinks: {
  main?: boolean
  href: string
  message: MessageDescriptor
  popover?: MessageDescriptor
  className?: string
  isExternal?: boolean
}[] = [
  { href: '/bokforing', message: messages.bookingSoftware },
  { href: '/fakturering', message: messages.invoiceSoftware },
  { href: '/lon', message: messages.payrollSoftware }, // SMELL: add salary page and fix this link
  { href: '/byra', message: messages.weBook },
  { href: '/hjalp', message: messages.help },
  {
    className: 'navigation-login',
    href: 'https://go.dooer.com/',
    isExternal: true,
    message: messages.logIn,
  },
]

const Navigation = ({ location }: INavigationProps) => {
  const [isOpen, setOpen] = React.useState(false)
  const isOnFree =
    location.pathname === '/' ||
    location.pathname.startsWith('/bokforing') ||
    location.pathname.startsWith('/lon') ||
    location.pathname.startsWith('/gratis') ||
    location.pathname.startsWith('/fakturering') ||
    location.pathname.startsWith('/partner')
  const isOnFeedback = location.pathname.startsWith('/feedback')
  const isOnLandingPage = location.pathname.startsWith('/lp/signup')
  const isOnNewCompaniesSignup = location.pathname.startsWith('/nya')

  // Use intl HOC
  const intl = useIntl()

  const showLinkPopovers = location.pathname.startsWith('/byra')
  const theme = 'free'

  const activeNav = isOnFree ? 2 : 1

  const renderNavLink = (
    link: {
      popover?: MessageDescriptor
      className?: string
      href: string
      main?: boolean
      isExternal?: boolean
      message: MessageDescriptor
    },
    isMobile = false
  ) => {
    const mobileProps: { onClick: () => void; variant: 'mobile' } = {
      onClick: () => setOpen(false),
      variant: 'mobile',
    }
    const standardProps = {
      className: cn(['visible-md', showLinkPopovers && link.popover && 'popOver', styles.navLink, link.className]),
      'data-popover-text': showLinkPopovers && link.popover ? intl.formatMessage(link.popover) : null,
      main: link.main,
    }
    return (
      <NavLink
        {...(isMobile ? mobileProps : standardProps)}
        href={link.href}
        isExternal={link.isExternal}
        key={link.href}
      >
        <FormattedMessage {...link.message} />
      </NavLink>
    )
  }

  return !isOnFeedback ? (
    <DevFeatureMiddleware location={location}>
      <header className={cn([styles.root, activeNav === 2 && styles.free, isOpen && styles.open])}>
        <div className={styles.inner}>
          <div className={styles.logo}>
            {isOnLandingPage ? (
              <DooerLogo theme="free" variant="responsive" />
            ) : (
              <a href="/">
                <DooerLogo theme="free" variant="responsive" />
              </a>
            )}
          </div>

          {isOnLandingPage ? null : isOnNewCompaniesSignup ? (
            <p className={styles.newCompaniesSignup}>
              <FormattedMessage {...messages.newCompaniesSignup} />
            </p>
          ) : (
            newLinks.map((link) => renderNavLink(link))
          )}

          {!isOnLandingPage && !isOnNewCompaniesSignup && (
            <Hamburger active={isOpen} className="hidden-md" onClick={() => setOpen(!isOpen)} theme={theme} />
          )}
        </div>
        {!isOnLandingPage && !isOnNewCompaniesSignup && (
          <div className={cn([styles.mobile, 'hidden-md'])}>{newLinks.map((link) => renderNavLink(link, true))}</div>
        )}
      </header>
      <div className={styles.spacer} />
    </DevFeatureMiddleware>
  ) : (
    <div />
  )
}

export default Navigation
